import { concatStyleSets } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { EUITextField } from './EUITextField';

export class EUINumericField extends Component {

    static defaultProps = {
        hideArrows: true,
        onChange: (event, newValue) => null,
        onDelayedChange: (event, newValue) => null,
        scale: 0,
        title: "", // Masque le tooltip
        type: "number"
    };

    static defaultState = {
        hasFocus: false,
    };

    constructor() {
        super();
        this.state = { ...EUINumericField.defaultState };
    };

    _onBlur = (event, newValue) => {
        const { onBlur } = this.props;
        this.setState({ hasFocus: false });
        if (typeof onBlur === "function") onBlur(event, newValue);
    };

    _onFocus = (event) => {
        const { onFocus } = this.props;
        this.setState({ hasFocus: true });
        if (typeof onFocus === "function") onFocus(event);
    };

    _onChange = (event, newValue) => {
        const { onChange } = this.props;
        if (typeof onChange === "function")
            onChange(event, newValue.replace(/[^\d.-]/g, ""));
    };

    _onDelayedChange = (event, newValue) => {
        const { onDelayedChange } = this.props;
        if (typeof onDelayedChange === "function")
            onDelayedChange(event, newValue.replace(/[^\d.-]/g, ""));
    };

    render = () => {

        const { hideArrows, scale, styles, type, value } = this.props;
        const { hasFocus } = this.state;

        let newProps = { ...this.props };
        if (hideArrows)
            newProps.styles = concatStyleSets(
                styles, // Autres styles éventuels
                {
                    field: {
                        "-moz-appearance": "textfield",
                        selectors: {
                            "&::-webkit-outer-spin-button": {
                                "-webkit-appearance": "none",
                                margin: 0
                            },
                            "&::-webkit-inner-spin-button": {
                                "-webkit-appearance": "none",
                                margin: 0
                            }
                        }
                    }
                }
            );

        // Value convertie en string sans quoi si égale à zéro alors la value disparaît onFocus
        let displayedValue = isNaN(value) || value === null ? value : value.toString();
        if (!hasFocus && type === "number")
            displayedValue = parseFloat(value).toFixed(scale);

        return <EUITextField
            {...newProps}
            onBlur={this._onBlur}
            onChange={this._onChange}
            onDelayedChange={this._onDelayedChange}
            onFocus={this._onFocus}
            type={type}
            value={displayedValue}
        />;

    }
}